import React from 'react';
import { Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { FormattedReactMessage } from '@atlassian/jira-project-settings-apps-common/src/i18n/formatted-react-message.tsx';

type Props = {
	errorMessage: MessageDescriptor;
};

export const ErrorMessage = ({ errorMessage }: Props) => {
	const intl = useIntl();

	return (
		<p>
			<FormattedReactMessage
				message={intl.formatMessage(errorMessage, {
					tagStart: '{tagStart}',
					tagEnd: '{tagEnd}',
				})}
				openingTag="{tagStart}"
				closingTag="{tagEnd}"
				Component={({ children }) => <Text as="strong">{children}</Text>}
			/>
		</p>
	);
};
